<template>
  <div class="ImportExcel">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="410px"
      :before-close="handleClose">
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="importPk">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>

      <el-dialog
        width="800px"
        title="失败列表"
        :visible.sync="innerVisible"
        append-to-body>
        <el-table :data="list" border>
          <el-table-column align="center" label="战队名称" prop="seasonTeamAName"></el-table-column>
          <el-table-column align="center" label="战队ID" prop="seasonTeamAId"></el-table-column>
          <el-table-column align="center" label="战队名称" prop="seasonTeamBName"></el-table-column>
          <el-table-column align="center" label="战队ID" prop="seasonTeamBId"></el-table-column>
          <el-table-column align="center" label="失败原因" prop="remark"></el-table-column>
        </el-table>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { importPk } from '@/api/season/vip.js'
export default {
  name: 'ImportExcel',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(v) {
      this.dialogVisible = v
    }
  },
  data () {
    return {
      dialogVisible: false,
      innerVisible: false,
      list: []
    }
  },
  methods: {
    async importPk(file) {
      let fm = new FormData()
      fm.append('file', file.file)
      const res = await importPk(fm)
      this.list = res.data || []
      if (!this.list.length) {
        this.$message.success('导入成功!')
      } else {
        this.innerVisible = true
      }
    },
    handleClose() {
      this.$emit('input', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.ImportExcel {
  .fr {
    float: right;
  }
}
</style>
